import { render } from "./CouponCard.vue?vue&type=template&id=084379f9&scoped=true&class=pa-0%20ma-0"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"

import "./CouponCard.vue?vue&type=style&index=0&id=084379f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084379f9"]])

export default __exports__